import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleCallback, getUserInfo } from './auth';
import { AuthContext } from './AuthContext';

function OAuthCallback() {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  useEffect(() => {
    handleCallback()
      .then(async () => {
        const u = await getUserInfo();
        setUser(u);
        setStatus('success');
        setMessage(`${u?.user_login || u?.preferred_username || '사용자'}님, 환영합니다!`);
        setTimeout(() => navigate('/simulator'), 1800);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.message || '로그인 처리 중 오류가 발생했습니다.');
      });
  }, []); // eslint-disable-line

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#060c1a', color: '#fff', flexDirection: 'column', gap: 16, padding: 24,
    }}>
      {status === 'processing' && (
        <>
          <div style={{ width: 48, height: 48, border: '3px solid rgba(99,102,241,0.3)', borderTopColor: '#6366f1', borderRadius: '50%', animation: 'spin 0.9s linear infinite' }} />
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>로그인 처리 중...</p>
        </>
      )}
      {status === 'success' && (
        <>
          <span style={{ fontSize: 40 }}>✅</span>
          <p style={{ fontWeight: 700, fontSize: 16 }}>{message}</p>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>잠시 후 분석기로 이동합니다...</p>
        </>
      )}
      {status === 'error' && (
        <>
          <span style={{ fontSize: 40 }}>❌</span>
          <p style={{ fontWeight: 700, fontSize: 16, color: '#f87171' }}>로그인 실패</p>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, textAlign: 'center' }}>{message}</p>
          <button
            onClick={() => navigate('/')}
            style={{ marginTop: 8, padding: '10px 24px', borderRadius: 12, background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', cursor: 'pointer', fontSize: 14 }}
          >
            홈으로 돌아가기
          </button>
        </>
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default OAuthCallback;
